// extracted by mini-css-extract-plugin
export var banner = "_qs-0";
export var settingRow = "_qs-2";
export var titleIcon = "_qs-1";